import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';
import './App.css';
import Main from 'components/main/Index';
import PrivacyTerms from 'components/terms/PrivacyTerms';
import ServiceTerms from 'components/terms/ServiceTerms';
import PersonalInformationTerms from 'components/terms/PersonalInformationTerms';
import PrivacyTermsApp from 'components/terms/PrivacyTermsApp';
import ProfileAnswerTerms from 'components/terms/ProfileAnswerTerms';
import ThirdPartyPrivacyTerms from 'components/terms/ThirdPartyPrivacyTerms';
import NPayPersonalInformationTerms from 'components/terms/npay/NPayPersonalInformationTerms';
import NPayThirdPartyPrivacyTerms from 'components/terms/npay/NPayThirdPartyPrivacyTerms';
import MarketingTerms from 'components/terms/MarketingTerms';

const App = (): JSX.Element => {
  return (
    <section className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/privacy-terms" element={<PrivacyTerms />} />
          <Route path="/privacy-terms/:period" element={<PrivacyTerms />} />
          <Route path="/privacy-terms/app" element={<PrivacyTermsApp />} />
          <Route path="/service-terms" element={<ServiceTerms />} />
          <Route path="/service-terms/:period" element={<ServiceTerms />} />
          <Route
            path="/personal-information-terms"
            element={<PersonalInformationTerms />}
          />
          <Route
            path="/profile-answer-terms/app"
            element={<ProfileAnswerTerms />}
          />
          <Route
            path="/profile-answer-terms/app/:period"
            element={<ProfileAnswerTerms />}
          />
          <Route
            path="/third-party-privacy-terms/app"
            element={<ThirdPartyPrivacyTerms />}
          />

          {/* ---------- 네이버페이 약관 ---------- */}
          {/* [필수] 개인정보 수집 및 이용 동의 */}
          <Route
            path="/npay/personal-information-terms"
            element={<NPayPersonalInformationTerms />}
          />
          {/* [필수] 개인정보 제3자 제공 동의 */}
          <Route
            path="/npay/third-party-privacy-terms"
            element={<NPayThirdPartyPrivacyTerms />}
          />
          {/* [선택] 마케팅 활용 동의 */}
          <Route path="/marketing-terms" element={<MarketingTerms />} />
        </Routes>
      </Router>
    </section>
  );
};

export default App;
